<template>
  <div class="tree-panel-filter">
    <input v-model="filter.searchterm" placeholder="search infobit" @keyup.enter="searchTree">
    <div class="context-filter">
      <input type="checkbox" id="checkbox" :disabled="!selectedInfobit" :checked="contextFilter"
        @change="setContextFilter">
      <label class="clickable" :disabled="!selectedInfobit" for="checkbox">context filter</label>
    </div>
  </div>
</template>

<script>
export default {

  computed: {

    treePanel () {
      return this.$store.state.treePanel
    },

    filter () {
      return this.treePanel.filter
    },

    contextFilter () {
      return this.filter.context
    },

    selectedInfobit () {
      return this.$store.state.infobitId
    }
  },

  methods: {

    searchTree () {
      this.$store.dispatch('searchTree')
    },

    setContextFilter () {
      this.$store.dispatch('setContextFilter', !this.contextFilter)
    }
  }
}
</script>

<style>
.tree-panel-filter input:focus {
  background-color: #fff;
}

.tree-panel-filter .context-filter {
  display: inline-block;
  margin-left: 2em;
}

.tree-panel-filter .context-filter label[disabled="disabled"].clickable:hover,
.tree-panel-filter .context-filter input[disabled="disabled"],
.tree-panel-filter .context-filter label[disabled="disabled"] {
  cursor: not-allowed;
  color: gray !important;
}
</style>



// WEBPACK FOOTER //
// tree-panel-filter.vue?a82726ba